import { Module, VuexModule, Action } from 'vuex-class-modules'
import axios from 'axios'

@Module
class RestorationWorkModule extends VuexModule {
  getAttachmentDataUrl (attachment) {
    return `/api/files/${attachment.bucket}/${attachment.key}`
  }

  getAttachmentIIIFUrl (attachment) {
    return attachment.iiif || this.getAttachmentDataUrl(attachment)
  }

  @Action
  async deleteAttachment ({ work, attachment }) {
    const workUrl = work.links.self
    return axios.delete(`${workUrl}/attachments/${attachment.key}`)
  }

  @Action
  async selectImg ({ itemUrl, img }) {
    return axios.post(
      `${itemUrl}/attachments/${img.key}`,
      { selected: img.selected, caption: img.caption })
  }
}

export default RestorationWorkModule
